import React from "react";
import "./Footer.css";
import { useTranslation } from "react-i18next";
import { SocialIcon } from "react-social-icons";
import { FaViber } from "react-icons/fa";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <div>
      <footer className="footer-section">
        <div className="container">
          <div className="footer-text fade-in">
            <div className="row">
              <div className="col-lg-4">
                <div className="ft-contact fade-in">
                  <h6>{t("footer.found")}</h6>
                  <div className="ft-about">
                    <div className="fa-social">
                      <SocialIcon
                        target="_blank"
                        rel="noopener noreferrer"
                        url="https://www.facebook.com/rafkonapartmentslxs/"
                        style={{ height: 30, width: 30 }}
                      />
                      <SocialIcon
                        target="_blank"
                        rel="noopener noreferrer"
                        url="https://www.instagram.com/rafkon_apartments/"
                        style={{ height: 30, width: 30 }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="ft-contact fade-in">
                  <h6> {t("footer.contact")}</h6>
                  <ul>
                    <li>
                      <a href="tel:+302254026424">+30 2254026424</a>
                    </li>
                    <li>
                      <a href="tel:+306981583591">+30 6981583591</a>
                      <SocialIcon
                        url="https://wa.me/306981583591"
                        style={{ height: 30, width: 30, marginLeft: 10 }}
                      />
                      <a
                        href="viber://chat?number=306981583591"
                        style={{
                          height: 30,
                          width: 30,
                          borderRadius: "50%",
                          background: "#7360F2",
                          alignItems: "center",
                          justifyContent: "center",
                          marginLeft: 10,
                        }}
                      >
                        <FaViber size={30} color="white" />
                      </a>
                    </li>
                    <li>
                      <a href="mailto:rafkonoe@gmail.com">rafkonoe@gmail.com</a>
                    </li>
                    <li>{t("footer.address")}</li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="ft-contact fade-in">
                  <h6>{t("footer.useful")}</h6>
                  <ul>
                    <li>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.astronlemnos.gr/"
                        className="bk-btn"
                      >
                        {t("footer.hotel")}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <p>Copyright © Rafkon Apartments 2023 - {new Date().getFullYear()} | All rights reserved</p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};
export default Footer;
